import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import useTableScroll from "../components/useTableScroll.js";
 
import { Mensaje } from '../components/mensajes';
import axios from "axios";
import moment from 'moment';
import {Dimmer} from "../components/spinner";
import { formatMoneda } from '../util/varios.js'; 

const CatalogoAprobacionesFondoTerc1 = props => {

    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));

    const btnCancela = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [values, setValues] = useState({});
    const [activo, setActivo] = useState(true);
    const [itemSelect, setItemSelect] = useState(-1);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const headCells = [
        { label: 'CÓDIGO', textAlign: 'center' },
        { label: 'DESCRIPCION', textAlign: 'center' },
        { label: 'FECHA', textAlign: 'center' },
        { label: 'MONTO', textAlign: 'center' },
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableScroll(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idaprobacion.includes(target.value)
                            || x.descripaprobacion.toLowerCase().includes(target.value.toLowerCase())
                            || formatMoneda(x.montototalaprob.toString().replace('.', ','), ',', '.', 2).includes(target.value)
                            || moment.utc(x.fechaaprobacion).format('DD/MM/YYYY').includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarFondos = () => {
        
        let endpoint = `${op.conexion}/api/catalogo/catalogoaprobacionesfondoterc1?idefiscal=${idefiscal}`;
    
        setActivate(true);
    
        axios.get(endpoint,{
            headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        }
          }).then(function (response) {
    
          if (response.status === 200) {

            setActivate(false);
            var data = []
            for (let i = 0; i < response.data.length; i++) {
                data.push({
                    idaprobacion: response.data[i].idaprobacion,
                    descripcion: response.data[i].descripcion,
                    montototalaprob: response.data[i].montototalaprob,
                    fechaaprobacion: response.data[i].fechaaprobacion,
                })
            }
            setRecords(data)   
          }  

    
        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        }).finally(function () {
            setActivate(false);
        });
    
      }

    const blanquear = () => {
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
        setItemSelect("");
        setActivo(true);
    }


    const cancelar = () => {

        blanquear();
        props.onHideCancelar();
    }

    const selectFondo = () => {

        var idaprobacion = values[0].idaprobacion;
        var descripcion = values[0].descripcion;
        var montototalaprob = values[0].montototalaprob;
        var fechaaprobacion = values[0].fechaaprobacion;
        

        blanquear();
        props.onHideAceptaFondos(idaprobacion, descripcion, montototalaprob, fechaaprobacion);
        props.onHideCancelar();
    };

    const seleccionarFila = (index) => (e) => {
        e.preventDefault();
        setItemSelect(index);
        setActivo(false);

        var idaprobacion = recordsAfterPagingAndSorting()[index].idaprobacion;
        var descripcion = recordsAfterPagingAndSorting()[index].descripcion;
        var montototalaprob = recordsAfterPagingAndSorting()[index].montototalaprob;
        var fechaaprobacion = recordsAfterPagingAndSorting()[index].fechaaprobacion;
        

        var datos = [];
        datos.push({
            idaprobacion,
            descripcion,
            montototalaprob,
            fechaaprobacion,

        })
        setValues(datos);

    };

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            size="lg"
            backdrop="static"
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            keyboard={false}
            onShow={() => {
                seleccionarFondos()
            }}
        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className="fw-bold text-light"><h3>{'Seleccionar Fondos'}</h3></div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className="col-md-12 m-0">

<div className="input-group input-group-sm mb-3 m-0 col-md-5">
    <input type='text'
        onChange={handleSearch} className="form-control rounded-pill search-input" />
</div>
</div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={index} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)} >
                                        <td className='py-2 text-center' style={{ width: '100px' }}>{item.idaprobacion}</td>
                                        <td className='py-2 text-start' style={{ width: '250px' }}>{item.descripcion}</td>
                                        <td className='py-2 text-right' style={{ width: '100px' }}>{formatMoneda(item.montototalaprob.toString().replace('.', ','), ',', '.', 2)}</td>
                                        <td className='py-2 text-center' style={{ width: '150px' }}>{moment.utc(item.fechaaprobacion).format('DD/MM/YYYY')}</td>
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-success rounded-pill" disabled={activo} style={{ margin: "5px" }} onClick={selectFondo}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoAprobacionesFondoTerc1;